import React, { useEffect, useState } from "react";
import $ from "jquery";
import axios from "axios";
import { Link, useOutletContext } from "react-router-dom";
import { useForm } from "react-hook-form";
import { MaterialReactTable } from "material-react-table";
import { useNavigate } from "react-router-dom";
import { decodeHtml } from "../../utils/decodeHtml";
import InvoiceStatusCell from "../client/InvoiceStatusCell";
import AddNewOrder from "../../components/Modals/Orders/AddNewOrder";
function Order() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { setGlobalLoading, token } = useOutletContext();
  const navigate = useNavigate();
  const [options, setoptions] = useState([]);
  const [optionsLoaded, setOptionsLoaded] = useState(false);
  const {register, setValue } = useForm();
  const [showAddOrderModal, setShowAddOrderModal] = useState(false);

  // Default to current financial year
  const today = new Date();
  const currentFY =
    today.getMonth() + 1 >= 4
      ? `${today.getFullYear()}-${today.getFullYear() + 1}`
      : `${today.getFullYear() - 1}-${today.getFullYear()}`;

  const [selectedYear, setSelectedYear] = useState(currentFY);

  const columns = [
    {
      accessorKey: "reference",
      header: "Order ID",
      size: 70,
    },
    {
      accessorKey: "company_name",
      header: "Clients",
      size: 70,
    },
    {
      accessorKey: "role_name",
      header: "Role Name",
      size: 70,
      Cell: ({ row }) => (
        <Link to={`/order/view/${row.original.id}`}>
          {decodeHtml(row.original.role_name)}
        </Link>
      ),
    },
    {
      accessorKey: "role_status",
      header: "Role Status",
      size: 70,
    },
    {
      accessorKey: "status",
      header: "Status",
      size: 70,
      Cell: ({ row }) => {
        return (
          <span>
            <InvoiceStatusCell role_id={row.original.role_id} />
          </span>
        );
      },
    },
    {
      accessorKey: "candidate_name",
      header: "Candidate Name",
      size: 70,
    },
    {
      accessorKey: "total_fees",
      header: "Total Fees",
      size: 70,
    },
  ];

  useEffect(() => {
    async function fetchOptions() {
      setGlobalLoading(true); //  Show loader before API call
      try {
        const response = await axios.get(
          `${API_BASE_URL}/orders/get_orders_list/?year=${selectedYear}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        console.log(response.data.orders);
        setoptions(response.data.orders || []);
        setOptionsLoaded(true);
      } catch (error) {
        console.error("API Error:", error);
        setoptions([]); // Prevent errors from breaking UI
        setOptionsLoaded(true);
      } finally {
        setOptionsLoaded(true);
        setGlobalLoading(false);
      }
    }
    fetchOptions();
  }, [selectedYear]);

  useEffect(() => {
    if (options.length > 0 || optionsLoaded) {
      setGlobalLoading(false);
      console.log(options);
    }
  }, [options]);

  useEffect(() => {
    $('[name="order_search"]').select2({
      multiple: false,
      closeOnSelect: true,
      ajax: {
        type: "POST",
        url: `${API_BASE_URL}/orders/orderLoad/`,
        dataType: "json",
        contentType: "application/json",
        delay: 250, // Delay for better UX
        beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", `Bearer ${token}`);
        },
        data: function (params) {
          console.log(
            "Sending JSON:",
            JSON.stringify({ keywords: params.term }),
          ); // Debugging
          return JSON.stringify({ keywords: params.term }); // ✅ Send JSON payload
        },
        processResults: function (data) {
          console.log(data.options);
          if (!data.options || data.options.length === 0) {
            return {
              results: [],
            };
          }
          return {
            results: data.options.map((item, index) => ({
              id: item.value, // ✅ Add prefix to the ID
              value: item.value,
              text: item.label,
            })),
          };
        },
        cache: true,
      },
      placeholder: "Search Orders",
      allowClear: true,
      minimumInputLength: 1,
      tags: false,
      language: {
        noResults: function () {
          return "No Order found"; // Ensure "No results found" is displayed
        },
      },
      escapeMarkup: function (markup) {
        return markup;
      },
    });

    $("[name='order_search']").on("change", function () {
      const selectedValues = $(this).val() || [];
      navigate(`/order/view/${selectedValues}`);
    });

    return () => {
      $("[name='order_search']").off("change"); // Cleanup on unmount
    };
  }, [token, API_BASE_URL, setValue]);

  const financialYears = Array.from({ length: 5 }, (_, i) => {
    const start = new Date().getFullYear() - i;
    const end = start + 1;
    return {
      label: `${start}-${end}`,
      value: `${start}-${end}`,
    };
  });

  return (
    <>
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Orders</h2>
          </div>
        </div>
        {showAddOrderModal && (
          <AddNewOrder
            onClose={() => {
              setShowAddOrderModal(false);
            }}
            token={token}
          />
        )}
        <div className="row justify-content-center" style={{ marginTop: "-20px" }}>
          <div style={{ cursor: "pointer" }} onClick={() => setShowAddOrderModal(true)} className="col-xl-2 col-md-2">
            <div className="card border-0">
              <div className="alert alert-default border border-default mb-0 p-3">
                <div className="d-flex align-items-start">
                  <div className="text-primary w-100">
                    <div className="fw-semibold text-center">
                      <i className="fa-solid fa-hand-holding-dollar fs-35"></i>
                    </div>
                    <div className="fs-12 text-center">
                      <a href="#" className="text-secondary fw-semibold">
                        Add New Order
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ cursor: "pointer" }} onClick={() => navigate("/order/revenue")} className="col-xl-2 col-md-2">
            <div className="card border-0">
              <div className="alert alert-default border border-default mb-0 p-3">
                <div className="d-flex align-items-start">
                  <div className="text-primary w-100">
                    <div className="fw-semibold text-center">
                      <i className="fa-solid fa-people-arrows fs-35"></i>
                    </div>
                    <div className="fs-12 text-center">
                      <Link to={"/order/revenue"} className="text-secondary fw-semibold me-2 d-inline-block">
                        Business Delivered
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ cursor: "pointer" }} onClick={() => navigate("/order/business")} className="col-xl-2 col-md-2">
            <div className="card border-0">
              <div className="alert alert-default border border-default mb-0 p-3">
                <div className="d-flex align-items-start">
                  <div className="text-primary w-100">
                    <div className="fw-semibold text-center">
                      <i className="fa-solid fa-fire fs-35"></i>
                    </div>
                    <div className="fs-12 text-center">
                      <Link to={"/order/business"} className="text-secondary fw-semibold me-2 d-inline-block">
                        Business Generated
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div style={{ cursor: "pointer" }} onClick={() => navigate("/order/collection")} className="col-xl-2 col-md-2">
            <div className="card border-0">
              <div className="alert alert-default border border-default mb-0 p-3">
                <div className="d-flex align-items-start">
                  <div className="text-primary w-100">
                    <div className="fw-semibold text-center">
                      <i className="fa-solid fa-thumbs-up fs-35"></i>
                    </div>
                    <div className="fs-12 text-center">
                      <Link to={"/order/collection"} className="text-secondary fw-semibold me-2 d-inline-block">
                        Collection
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          <div style={{ cursor: "pointer" }} onClick={() => navigate("/order/outstanding")} className="col-xl-2 col-md-2">
            <div className="card border-0">
              <div className="alert alert-default border border-default mb-0 p-3">
                <div className="d-flex align-items-start">
                  <div className="text-primary w-100">
                    <div className="fw-semibold text-center">
                      <i className="fa-solid fa-magnifying-glass fs-35"></i>
                    </div>
                    <div className="fs-12 text-center">
                      <Link to={"/order/outstanding"} className="text-secondary fw-semibold me-2 d-inline-block">
                        Outstanding
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ cursor: "pointer" }} onClick={() => navigate("/order/atrisk")} className="col-xl-2 col-md-2">
            <div className="card border-0">
              <div className="alert alert-default border border-default mb-0 p-3">
                <div className="d-flex align-items-start">
                  <div className="text-primary w-100">
                    <div className="fw-semibold text-center">
                      <i className="fa-solid fa-fire fs-35"></i>
                    </div>
                    <div className="fs-12 text-center">
                      <Link to={"/order/atrisk"} className="text-secondary fw-semibold me-2 d-inline-block">
                        Invoice At Risk
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-header d-flex align-items-center justify-content-between">
            {/* LEFT SIDE - 50% width */}
            <div className="d-flex align-items-center" style={{ width: "50%" }}>
              <h5 className="mb-0 me-2">Quick Search:</h5>

              <div style={{ flex: 1 }}>
                <div className="input-icon-end position-relative remove-icon">
                  <select
                    style={{ width: "100%" }}
                    {...register("order_search", { required: false })}
                    id="select-client"
                  ></select>
                </div>
              </div>
            </div>

            {/* RIGHT SIDE */}
            <div className="d-flex align-items-center gap-2">
              <label className="mb-0">Year:</label>
              <div style={{ width: "119px" }}>
                <select
                  className="form-select"
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                >
                  {financialYears.map((fy) => (
                    <option key={fy.value} value={fy.value}>
                      {fy.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          <div className="card-body p-0">
            <div className="custom-datatable-filter table-responsive">
              <div className="row p-4 mt-3">
                {options.length > 0 && (
                  <MaterialReactTable
                    columns={columns}
                    data={options}
                    enableGrouping
                    initialState={{
                      density: "compact",
                      grouping: ["company_name"], // group by role_name
                      expanded: true, // expand groups by default
                      pagination: { pageSize: 100 },
                      columnOrder: [
                        "id",
                        "role_name",
                        "company_name",
                        "role_status",
                        "status",
                        "candidate_name",
                        "total_fees",
                      ],
                      columnPinning: {
                        left: [], // 👈 no pinned columns
                        right: [],
                      },
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Order;
